<template>
  <div>
    <h3 class="title is-3">
      <router-link to="/">
        <b-icon icon="chevron-left" size="is-small"></b-icon>
      </router-link>&nbsp;
      New Tournament
    </h3>
    <hr>
    <!-- featured id -->
    <b-field label="Sport">
      <b-select placeholder="Select a Sport" v-model="sport" expanded>
        <option
          v-for="sportOption in sports"
          :value="sportOption"
          :key="sportOption"
        >{{ sportOption }}</option>
      </b-select>
    </b-field>
    <!-- name -->
    <div class="field">
      <label class="label">Name</label>
      <div class="control">
        <input class="input" type="text" placeholder="Absa Premiership" v-model="name">
      </div>
    </div>
    <!-- slug -->
    <div class="field">
      <label class="label">Slug</label>
      <div class="control">
        <input class="input" type="text" placeholder="absa-premiership" v-model="slug">
      </div>
    </div>
    <!-- image -->
    <b-field class="file">
      <b-upload v-model="file" accept="image/png">
        <a class="button is-primary">
          <b-icon icon="upload"></b-icon>
          <span>Click to add logo</span>
        </a>
      </b-upload>
      <span class="file-name" v-if="file">{{ file.name }}</span>
      <!-- <b-icon icon="weight" size="is-small" style="margin-left:10px;"></b-icon> -->
    </b-field>
    <div class="columns">
      <div class="column">
        <!-- enabled -->
        <div class="field">
          <label class="label">Enabled</label>
          <b-switch type="is-success" v-model="enabled"></b-switch>
        </div>
      </div>
      <div class="column">
        <!-- live scored -->
        <div class="field">
          <label class="label">Live Scored</label>
          <b-switch type="is-success" v-model="live_scored"></b-switch>
        </div>
      </div>
      <div class="column">
        <!-- save button -->
        <div class="field">
          <button @click="save" class="button is-primary">Save Tournament</button>
        </div>
      </div>
    </div>
    <loading v-if="loading"></loading>
  </div>
</template>

<script>
import { CREATE_FEED } from "@/store/actions";
import loading from "@/components/Loading";

export default {
  name: "FeedNew",
  components: {
    loading
  },
  data() {
    return {
      sports: ["Football", "Rugby", "Cricket", "Golf", "Motorsport", "Tennis"],
      sport: null,
      name: "",
      slug: "",
      enabled: true,
      live_scored: true,
      loading: false,
      file: null
    };
  },
  methods: {
    save() {
      this.readFileAsImage(this.file)
        .then(loadedFile => {
          if (loadedFile.width !== 160) {
            this.$warning("Image is too wide. Must be exactly 160x160");
          } else if (loadedFile.height !== 160) {
            this.$warning("Image is too tall. Must be exactly 160x160");
          } else if (this.name.trim().length <= 0) {
            this.$warning("The name is required");
          } else if (this.slug.trim().length <= 0) {
            this.$warning("The slug is required");
          } else if (!this.sport || this.sport.trim().length <= 0) {
            this.$warning("The sport is required");
          } else {
            this.loading = true;

            let data = new FormData();
            data.append("sport", this.sport);
            data.append("name", this.name.trim());
            data.append("slug", this.slug.trim().toLowerCase());
            data.append("enabled", this.enabled);
            data.append("live_scored", this.live_scored);
            data.append("file", this.file);

            this.$store
              .dispatch(CREATE_FEED, data)
              .then(res => {
                if (res.status === 204) {
                  this.$success("Tournament created successfully");
                  this.sport = null;
                  this.name = "";
                  this.slug = "";
                } else {
                  this.$warning("Something went wrong, please try again");
                }
              })
              .catch(err => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.errors
                ) {
                  err.response.data.errors.forEach(error => {
                    this.$warning(error);
                  });
                } else {
                  this.$warning("Something went wrong, please try again");
                }
              })
              .finally(() => {
                this.loading = false;
              });
          }
        })
        .catch(err => {
          this.$warning("Failed to read image");
        });
    },
    readFileAsImage(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader();

        fr.onload = () => {
          const img = new Image();

          img.onload = () => {
            resolve(img);
          };

          img.onerrorerr = err => {
            reject(err);
          };

          img.src = fr.result;
        };

        fr.readAsDataURL(file);
      });
    }
  },
  watch: {
    file(newVal, oldVal) {
      console.log(oldVal, newVal);
      window.file_test = newVal;
    }
  }
};
</script>
